import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  modal: {
    position: 'absolute',
    borderWidth: 0,
  },
  container: {
    flex: 1,
    backgroundColor: '#000',
    opacity: 0.6,
  },
  modalBox: {
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    position: 'absolute',
    justifyContent: 'center',
  },
  modalContentLarge: {
    flexDirection: 'column',
    alignSelf: 'center',
    justifyContent: 'center',
    marginRight: 250,
    paddingHorizontal: 5,
    paddingVertical: 10,
    borderRadius: 10,
    backgroundColor: '#FFFFFF',
    marginTop: 270,
  },
  modalContentSmall: {
    flexDirection: 'column',
    alignSelf: 'center',
    justifyContent: 'center',
    paddingHorizontal: 2,
    paddingVertical: 2,
    borderRadius: 10,
    backgroundColor: '#FFFFFF',
    marginTop: 230,
    marginLeft: 48,
  },
  closeIconContainer: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-end',
  },
  titleContainer: {
    flexDirection: 'row',
    width: '100%',
    marginBottom: 5,
    justifyContent: 'center',
  },
  textTitle: {
    alignSelf: 'center',
    marginRight: 10,
  },
  textTitleArrow: {
    alignSelf: 'center',
    marginLeft: 10,
  },
  checkBoxOutsideContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  checkBoxInsideContainer: {
    backgroundColor: '#FFFFFF',
    borderWidth: 0,
  },
});
